import { useAppStore, type PanelFlyoutId } from '../../state/store';
import { Icon } from '../components/controls';

const INFO_PATH =
  'M12 3a9 9 0 100 18 9 9 0 000-18zm0 4a1.25 1.25 0 110 2.5A1.25 1.25 0 0112 7zm-1.25 4h2.5v6h-2.5v-6z';
const PROPERTIES_PATH =
  'M4 7h10M4 12h16M4 17h12M16 5.5v3M20 10.5v3M14 15.5v3';
const BRUSH_PATH =
  'M5 19l2.2-1.1L17.5 7.6a2.1 2.1 0 10-3-3L4.2 14.9 3 19l2- .05zM14 5.5l3.5 3.5';
const NAV_PATH =
  'M4 16l4-8 3 5 2-3 5 6H4zM16 7a2 2 0 110 4 2 2 0 010-4z';

interface RailButton {
  id: PanelFlyoutId;
  title: string;
  label?: string;
  path?: string;
  group?: 'start';
}

const RAIL_BUTTONS: RailButton[] = [
  { id: 'info', title: 'Info', path: INFO_PATH, group: 'start' },
  { id: 'properties', title: 'Properties', path: PROPERTIES_PATH },
  { id: 'brush', title: 'Brush', path: BRUSH_PATH, group: 'start' },
  { id: 'character', title: 'Character', label: 'Tt', group: 'start' },
  { id: 'paragraph', title: 'Paragraph', label: '¶' },
  { id: 'histogram', title: 'Histogram', label: 'Hs' },
];

/**
 * Far-right icon strip: toggles flyout panels, collapse hides the dock body.
 */
export function PanelRail() {
  const flyout = useAppStore((state) => state.panelFlyout);
  const navigatorOpen = useAppStore((state) => state.panels.navigator);
  const panelColumnHidden = useAppStore((state) => state.panelColumnHidden);
  const togglePanelFlyout = useAppStore((state) => state.togglePanelFlyout);
  const togglePanel = useAppStore((state) => state.togglePanel);
  const togglePanelColumn = useAppStore((state) => state.togglePanelColumn);

  return (
    <aside className="panel-rail" aria-label="Panel shortcuts">
      <button
        type="button"
        className="panel-rail__btn"
        title={panelColumnHidden ? 'Expand panels' : 'Collapse panels'}
        aria-pressed={!panelColumnHidden}
        onClick={togglePanelColumn}
      >
        <span className="panel-rail__glyph">{panelColumnHidden ? '»' : '«'}</span>
      </button>
      <button
        type="button"
        className={`panel-rail__btn panel-rail__btn--group${
          navigatorOpen && !panelColumnHidden ? ' panel-rail__btn--active' : ''
        }`}
        title="Navigator"
        aria-pressed={navigatorOpen && !panelColumnHidden}
        onClick={() => togglePanel('navigator')}
      >
        <Icon size={19} path={NAV_PATH} />
      </button>
      {RAIL_BUTTONS.map((button) => {
        const active = flyout === button.id && !panelColumnHidden;
        return (
          <button
            key={button.id}
            type="button"
            className={`panel-rail__btn${active ? ' panel-rail__btn--active' : ''}${
              button.group === 'start' ? ' panel-rail__btn--group' : ''
            }`}
            title={button.title}
            aria-pressed={active}
            onClick={() => togglePanelFlyout(button.id)}
          >
            {button.path ? (
              <Icon size={19} path={button.path} />
            ) : (
              <span className="panel-rail__glyph">{button.label}</span>
            )}
          </button>
        );
      })}
    </aside>
  );
}
